import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
export const exportConfig = (config:any) => {
  const appFirebase = initializeApp(config);
  const auth = getAuth(appFirebase);
  return { appFirebase, auth };
}
